// @flow

import { startRequest, finishRequest } from "@store/utils";
import type { EmployeesState } from "@modules/employee/reducer";

export const setLoading = (state: EmployeesState) => () => ({
  ...state,
  employee: {
    ...startRequest(state.employee),
  },
});
export const setLoaded = (state: EmployeesState) => () => ({
  ...state,
  employee: {
    ...finishRequest(state.employee),
  },
});

export const onUpdateEmployeeDetails = (state: EmployeesState) => () => ({
  ...state,
  error: null,
  employee: {
    ...startRequest(state.employee),
  },
});
export const onUpdateEmployeeDetailsSuccess = (state: EmployeesState) => () => ({
  ...state,
  error: null,
  employee: {
    ...finishRequest(state.employee),
  },
});
export const onGetEmployeeSuccess = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  error: null,
  employee: {
    ...finishRequest(state.employee),
    personalDetails: payload,
  },
});

export const onGetEmployeeActionSummarySuccess = (state: EmployeesState) => ({
  payload,
}: Object) => ({
  ...state,
  error: null,
  employee: {
    ...finishRequest(state.employee),
    actionSummary: payload,
  },
});

export const onGetEmployeeChangelogSuccess = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  error: null,
  employee: {
    ...finishRequest(state.employee),
    changelog: {
      ...state.employee.changelog,
      list: payload,
    },
  },
});

export const onResetEmployeeChangelog = (state: EmployeesState) => () => ({
  ...state,
  employee: {
    ...state.employee,
    changelog: {
      ...state.employee.changelog,
      list: {
        ...state.employee.changelog.list,
        content: [],
      },
    },
  },
});

export const onGetEmployeeChangelogError = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  error: payload,
  employee: {
    ...finishRequest(state.employee),
    changelog: {
      ...state.employee.changelog,
      list: {
        ...state.employee.changelog.list,
        content: [],
      },
    },
  },
});

export const onGetEmployeeSchemaSuccess = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...finishRequest(state.employee),
    schema: payload,
  },
});

export const onGetEmployeeSchemaError = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  error: payload,
  employee: {
    ...finishRequest(state.employee),
  },
});

export const onGetAddEmployeeSchemaSuccess = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    addEmployeeSchema: payload,
  },
});

export const onGetAddEmployeeSchemaError = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  error: payload,
});

export const onUpdateEmployeeDetailsError = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  error: payload,
  employee: {
    ...finishRequest(state.employee),
  },
});

export const onSetShowExcludeEmployeeFromAlertsAddModal = (state: EmployeesState) => ({
  payload,
}: $Exact<{
  action: string,
  payload: $Exact<{
    visible: boolean,
    step: number,
  }>,
}>) => ({
  ...state,
  employee: {
    ...state.employee,
    modals: {
      ...state.employee.modals,
      addAlertExclusion: {
        ...state.employee.modals.addAlertExclusion,
        visible: payload.visible,
        step: payload.step,
      },
    },
  },
});

export const onGetEmployeeAlertExclusions = (state: EmployeesState) => () => startRequest(state);

export const onGetEmployeeAlertExclusionsSuccess = (state: EmployeesState) => ({
  payload,
}: Object) => ({
  ...state,
  employee: {
    ...finishRequest(state.employee),
    employeeAlertExclusions: payload,
  },
});

export const onGetEmployeeAlertExclusionsError = (state: EmployeesState) => ({
  payload,
}: Object) => ({
  ...state,
  error: payload,
  employee: {
    ...finishRequest(state.employee),
  },
});

export const onSetShowRemoveAlertExclusionModal = (state: EmployeesState) => ({
  payload,
}: $Exact<{
  action: string,
  payload: $Exact<{
    visible: boolean,
    employeeAlertExclusionId: ?number,
    alertName: ?string,
  }>,
}>) => ({
  ...state,
  employee: {
    ...state.employee,
    modals: {
      ...state.employee.modals,
      removeAlertExclusion: {
        ...state.employee.modals.removeAlertExclusion,
        visible: payload.visible,
        alertName: payload.alertName || null,
      },
      employeeAlertExclusionId: payload.employeeAlertExclusionId || null,
    },
  },
});

export const onSetShowEditAlertExclusionModal = (state: EmployeesState) => ({
  payload,
}: $Exact<{
  action: string,
  payload: $Exact<{
    visible: boolean,
    employeeAlertExclusionId: ?number,
    alertId: ?number,
  }>,
}>) => ({
  ...state,
  employee: {
    ...state.employee,
    modals: {
      ...state.employee.modals,
      editAlertExclusion: {
        ...state.employee.modals.editAlertExclusion,
        visible: payload.visible,
      },
      employeeAlertExclusionId: payload.employeeAlertExclusionId || null,
      alert: { id: payload.alertId } || null,
    },
  },
});

export const onSetEmployeeAlertExclusionSchema = (state: EmployeesState) => ({
  payload,
}: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    employeeAlertExclusionSchema: payload,
  },
});

export const onGetClientAlertSuccess = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    modals: {
      ...state.employee.modals,
      alert: payload,
    },
  },
});

export const onSetExclusionReasonDetails = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    modals: {
      ...state.employee.modals,
      exclusionReasonDetails: payload,
    },
  },
});

export const onClearDataAlertExlusionForm = (state: EmployeesState) => () => ({
  ...state,
  employee: {
    ...state.employee,
    modals: {
      ...state.employee.modals,
      exclusionReasonDetails: null,
      alert: null,
      employeeAlertExclusionId: null,
    },
  },
});
